import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Map } from '@widgets/Map'

import { PageContentLayout } from '@layouts/PageContentLayout'
import { AppLoader } from '@components/AppLoader'
import { MapControls } from '@components/MapControls'

import { useLazyFetchMapConfigByIdQuery } from '@redux/api'

import { MAP_DEFAULT_SETTINGS_PROPERTIES } from '@constants'

export const MapPage = () => {
  const { id: mapConfigId } = useParams()

  const [isLoading, setIsLoading] = useState(true)

  const [fetchMapConfigById, { data: mapConfig }] = useLazyFetchMapConfigByIdQuery()

  useEffect(() => {
    // При смене ID карты повторно загружаем конфиг
    if (!isNaN(Number(mapConfigId))) {
      setIsLoading(true)

      fetchMapConfigById({ id: Number(mapConfigId) })
        .unwrap()
        .finally(() => setIsLoading(false))

      return
    }

    setIsLoading(false)
  }, [mapConfigId])

  // Не показываем карту, пока конфиг не совпадает с текущим id (защита от гонки при быстром переключении)
  if (isLoading || !mapConfig || mapConfig.id !== Number(mapConfigId)) {
    return <AppLoader />
  }

  return (
    <PageContentLayout>
      <div style={{ width: '100%', height: '100%', position: 'relative' }}>
        <Map
          key={mapConfigId}
          config={{
            ...mapConfig,
            mapSettings: {
              ...mapConfig.mapSettings,
              ...MAP_DEFAULT_SETTINGS_PROPERTIES,
            },
          }}
        >
          <MapControls />
        </Map>
      </div>
    </PageContentLayout>
  )
}
